import {
  FETCH_DEPARTMENTS,
  FETCH_DEPARTMENTS_SUCCESS,
  FETCH_DEPARTMENTS_FAILURE,
  CREATE_DEPARTMENT_REQUEST,
  CREATE_DEPARTMENT_SUCCESS,
  CREATE_DEPARTMENT_FAILURE,
  DELETE_DEPARTMENT,
  DELETE_DEPARTMENT_SUCCESS,
  DELETE_DEPARTMENT_FAILURE,
} from "./actionTypes";

const initialState = {
  departments: [],
  loading: false,
  error: null,
  success:false
};

const departmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DEPARTMENTS:
      return { ...state, loading: true, error: null };

    case FETCH_DEPARTMENTS_SUCCESS:
      return { ...state, loading: false, departments: action.payload.data };

    case FETCH_DEPARTMENTS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case CREATE_DEPARTMENT_REQUEST:
      return { ...state, loading: true, error: null };

    case CREATE_DEPARTMENT_REQUEST:
          return { ...state, loading: true, success:false, error: null };
        
    case CREATE_DEPARTMENT_SUCCESS:
      return { ...state, loading: false, success:true, departmentData: action.payload, error: null };

    case CREATE_DEPARTMENT_FAILURE:
      return { ...state, loading: false, success:false, error: action.payload };

    case DELETE_DEPARTMENT:
      return { ...state, loading: true, success:false, error: null }; // Clear previous errors
    
    case DELETE_DEPARTMENT_SUCCESS:
      return { ...state, loading: false, success:true, deleteResponse: action.payload, error: null };
    
    case DELETE_DEPARTMENT_FAILURE:
      return { ...state, loading: false, success:false, error: action.payload };

    default:
      return state;
  }
};

export default departmentReducer;
